import { idPlantChanged } from './../root/state/root-actions';
import { setBrowserUrl } from './browser-history';

export function nodeChanged(idPlant, modelCode, dispatch) {
  setBrowserUrl(idPlant);
  dispatch(idPlantChanged(idPlant, modelCode));
}

export function gotoNodeWithoutBrowserKnowing(idPlant, modelCode, dispatch) {
  dispatch(idPlantChanged(idPlant, modelCode));
}


/** WEBPACK FOOTER **
 ** app/components/common/broadcast-helper.js
 **/